export default __webpack_public_path__ + "static/media/menu.5562ee1f.svg";